module.exports = __webpack_public_path__ + "img/GitHub-Logo.92e5f979.png";